import { DeleteModal } from "@/components/modal/DeleteModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { deleteSshKeyMutation } from "@/modules/compute/sshKeysQuery.ts";
import { Trans } from "@lingui/react/macro";
import type { SshKey } from "@warrenio/api-spec/spec.oats.gen";

export function SshKeyDeleteModal({ item: { name, uuid } }: { item: SshKey }) {
    const mutation = useStandardMutation(deleteSshKeyMutation);

    return (
        <DeleteModal
            inTable
            modalAction={async () => {
                await mutation.mutateAsync({ uuid });
            }}
        >
            <Trans>Are you sure you want to delete the public key "{name}"?</Trans>
        </DeleteModal>
    );
}
